/*******************************************************************************************/
/************************************************************************** SessionStorage */
/*******************************************************************************************/
// Variable 'bCambios'.
// Elimina la clave 'bCambios' de sessionStorage.
export function removeCambiosPendientes() {
    sessionStorage.removeItem('bCambios');
}

// Recupera de sessionStorage el valor que haya en la clave 'bCambios'.
export function hayCambiosPendientes() {
    return parseBool(sessionStorage.getItem('bCambios'));
}

// Establece el valor indicado (status) en la clave 'bCambios' de sessionStorage.
export function setCambiosPendientes(status) {
    sessionStorage.setItem('bCambios', status);
}

// Variable 'indiceFila'.
// Elimina la clave 'indiceFila' de sessionStorage.
export function removeIndiceFila() {
    sessionStorage.removeItem('indiceFila');
}

// Recupera de sessionStorage el valor que haya en la clave 'indiceFila'.
export function getIndiceFila() {
    return parseInt(sessionStorage.getItem('indiceFila'));
}

// Establece el valor indicado (index) en la clave 'indiceFila' de sessionStorage.
export function setIndiceFila(index) {
    sessionStorage.setItem('indiceFila', index);
}

export function setMockuserSession(NPersonal) {
    sessionStorage.setItem('mockuser_npersonal', NPersonal);
}

export function getMockuserSession() {
    return sessionStorage.getItem('mockuser_npersonal');
}

export function removeMockuserSession() {
    sessionStorage.removeItem('mockuser_npersonal');
}

export function setPeriodoSession(periodo) {
    sessionStorage.setItem('mockuser_periodo', JSON.stringify(periodo));
}

export function getPeriodoSession() {
    return JSON.parse(sessionStorage.getItem('mockuser_periodo'));
}

export function removePeriodoSession() {
    sessionStorage.removeItem('mockuser_periodo');
}
/**********************************************************************************************/
/************************************************************************** Funciones casting */
/**********************************************************************************************/

// Comprueba si el valor de entrada es true en términos generales. Devuelve un valor booleano.
export function parseBool(str) {
    str = str.replace(/\s/g, '');

    return (str === 'true' || (!isNaN(str) && str !== '0')) ? true : false;
};

/***************************************************************************************************/
/************************************************************************** Funciones flags (bool) */
/***************************************************************************************************/
export function removeFlag(name) {
    sessionStorage.removeItem(name);
}

export function setFlag(name, value) {
    sessionStorage.setItem(name, JSON.stringify(value));
}

export function getFlag(name) {
    return parseBool(sessionStorage.getItem(name));
}

/***************************************************************************************************/
/******************************************************************************** Funciones fechas */
/***************************************************************************************************/
export const formatDate = (date, format) => {
    const map = {
        MM: ("0" + (date.getMonth() + 1)).slice(-2),
        dd: ("0" + date.getDate()).slice(-2),
        yy: date.getFullYear().toString().slice(-2),
        yyyy: date.getFullYear(),
        hh: ('0' + date.getHours()).slice(-2),
        mm: ('0' + date.getMinutes()).slice(-2)
    }

    return format.replace(/MM|dd|yyyy|yy|hh|mm/gi, matched => map[matched])
};

export const addMonthsToDate = (date, numberOfMonths, format) => {
    let newDate = new Date(date);
    newDate.setMonth(newDate.getMonth() + numberOfMonths);

    return (undefined != format) ? formatDate(newDate, format) : newDate;
};